import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useOps } from "../OpsOverview";
import { DashboardGpsMap } from "../DashboardGpsMap";
import { KpiRow } from "./KpiRow";
import { AiAssistant, NextActions } from "./AiPanels";
import { TodayServices } from "./TodayServices";
import { Planning } from "./Planning";
import { Opportunities } from "./Opportunities";
import { Fleet, Maintenance, Analytics } from "./BottomRow";

export function ExecBoard({ weather, expirations, compact = false, onData }) {
  const [x, setX] = useState(null);
  const [err, setErr] = useState(false);
  const o = useOps();
  const load = useCallback(() => api.get("/dashboard/exec").then(r => { setX(r.data); setErr(false); onData && onData(r.data); }).catch(() => setErr(true)), [onData]);
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, [load]);
  if (compact) return (
    <div className="nx-board space-y-3" data-testid="nx-board">
      <h2 className="font-display text-lg text-[#E9C46A] pt-2">Strumenti operativi</h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        <AiAssistant />
        <NextActions actions={x?.actions || []} alerts={o?.alerts} />
        <Opportunities items={x?.opportunities || []} />
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-3">
        <div className="xl:col-span-7 min-w-0"><Planning plan={x?.planning} nowMin={x?.now_min} onReload={load} /></div>
        <div className="xl:col-span-5 min-w-0 space-y-3"><Analytics a={x?.analytics} /><Fleet items={x?.fleet || []} /></div>
      </div>
    </div>
  );
  return (
    <div className="nx-board space-y-3" data-testid="nx-board">
      {err && <div className="text-xs text-rose-300" data-testid="nx-error">Dati della dashboard non disponibili al momento</div>}
      <KpiRow k={x?.kpis} weather={weather} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-3">
        <div className="xl:col-span-6 min-w-0"><DashboardGpsMap title="Operatività in tempo reale" /></div>
        <div className="xl:col-span-3 min-w-0"><AiAssistant /></div>
        <div className="xl:col-span-3 min-w-0"><NextActions actions={x?.actions || []} alerts={o?.alerts} /></div>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-3">
        <div className="xl:col-span-3 min-w-0"><TodayServices items={x?.today_services || []} /></div>
        <div className="xl:col-span-5 min-w-0"><Planning plan={x?.planning} nowMin={x?.now_min} onReload={load} /></div>
        <div className="xl:col-span-4 min-w-0"><Opportunities items={x?.opportunities || []} /></div>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-3">
        <div className="xl:col-span-5 min-w-0"><Fleet items={x?.fleet || []} /></div>
        <div className="xl:col-span-3 min-w-0"><Maintenance items={expirations} /></div>
        <div className="xl:col-span-4 min-w-0"><Analytics a={x?.analytics} /></div>
      </div>
    </div>
  );
}
